export const certificates = [
    {
        "id":1,
        "date": "JUNE 2022",
        "name": "Microsoft Azure Fundamentals (AZ-900)",
        "link": "https://drive.google.com/file/d/1D_wn663PjfVyh--IjFfGMVH9fq9KzM2x/view?usp=sharing"
    },
    {
        "id":2,
        "date": "JUNE 2020",
        "name": "SparkAR Certification (sv.co and facebook)",
        "link": "https://drive.google.com/file/d/1QSGZ9OO6nx5sH_vmBE5I7ADaFU2sAeP6/view?usp=sharing"
    },
];